// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { FirebaseOptions } from '@angular/fire/app';

/**
 * These are the configuration values on Firestore for the DEV Account
 *
 * # Firebase Config
 * @example
 * ```
 * Tes
 * ```
 * ## Branching and Deploy Structure
 * @example
 * ```
 * Branch ──>── DB
 * Branch ══>══ DEPLOY What Branch
 *
 *                                 ╔═══════════╗
 * ┌────────┐     ┌──> DEPLOY ═>═══╣ QA SITE   ╠══<──┐
 * │ QA     ├──>──┤                ╚═══════════╝     │
 * └────────┘     └──> DB ──┐                        │
 *                          │                        ^
 *                          v                  ┌─────┴─────┐
 * ┌────────┐     ┌──> DB ──┴──>─────────────>─┤ MASTER DB │
 * │ MASTER ├──>──┤                            └─┬─────────┘
 * └────────┘     └──> DEPLOY ═>═╗               v
 *                               ║ ╔════════╗    │
 *                               ╠═╣ GALLIX ╠══<─┘
 *                               ║ ╚════════╝
 *                               ║
 *                     ╔═════════╩═╗
 *                     ║ DEMO SITE ╠══<──────────────┐
 *                     ╚═══════════╝                 ^
 *                                                   │
 *                                 ╔═══════════╗     │
 * ┌────────┐     ┌──> DEPLOY ═>═══╣ DEV SITE  ╠══<──┤
 * │ DEV    ├──>──┤                ╚═══════════╝     │
 * └────────┘     └──> DB ──┐                        │
 *                          │                        ^
 *                          v                  ┌─────┴─────┐
 *                          └──>─────────────>─┤ QA DB     │
 *                                             └───────────┘

 * ```
 */
export const environment = {
  environment: 'Dev',
  versionDocumentId: 'version_dev',
  production: false,
  typeSenseKey: 'ly8b1zmsn4ikrqctp',
  storageUrl: 'gs://gallix-qa.appspot.com',
  firebaseConfig: {
    apiKey: 'AIzaSyBvoX7ultn4eUAUVENdbq2EkNXBrMCckN4',
    authDomain: 'gallix-qa.firebaseapp.com',
    projectId: 'gallix-qa',
    storageBucket: 'gallix-qa.appspot.com',
    messagingSenderId: '695323828389',
    appId: '1:695323828389:web:8f9fbdda36afd66088ed4c',
    measurementId: 'G-K4KT67B6EL',
  } as FirebaseOptions,
  gallixApi: 'https://gallix-api-rqnxwvtcqq-bq.a.run.app/api/v1',
  gallixDocumentsApi: 'https://gallix-api-rqnxwvtcqq-bq.a.run.app/api/v1',
  gallixCoreApi: 'https://gallix-core-api-695323828389.africa-south1.run.app' as const,
  microsoftMail: {
    emailerOrigin: 'https://gallix-emailer-695323828389.africa-south1.run.app',
    siteOrigin: 'https://dev.gallix.app',
    returnPath: '/settings/mail',
  },
  lookerStudio: {
    apiKey: '7cef0a4c-82a4-4dfd-a781-3854cede4f6b',
  },
  dynamsoft: {
    apiKey:
      'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0NTg2NDQzLTEwNTMwNDA5NSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21kbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwNDU4NjQ0MyIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NkbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJjaGVja0NvZGUiOi01MzM0NzcxMzV9',
  },
};
